<template>
  <div>
    <!-- <h2 style="margin:10px;">Product Category</h2> -->
    <!-- <hr /> -->
    <v-card style="margin-top:20px;margin-left:20px;margin-right:20px;">
      <v-container fluid ma-0 pa-0 fill-height grid-list-xl>
        <v-layout row justify-space-around>
          <v-flex md5 v-if=" photos!=''">
            <!-- <div style="width:auto">
              <v-img :src="'https://api.inguzsales.in/u/'+photos[0]" />
            </div>-->
            <div style="width:auto">
              <img
                class="role"
                v-if="!imageDisplay"
                v-bind:src="'https://api.inguzsales.in/u/'+photos[0]"
                style="width:100%;height:auto;"
              />
              <img class="role" v-else v-bind:src="imageDisplay" style="width:100%;height:auto;" />
            </div>
            <div>
              <vue-select-image
                :dataImages="dataImages"
                h="70px"
                w="70px"
                @onselectimage="onSelectImage"
                style="padding-left:0px"
              ></vue-select-image>
            </div>
            <!-- <v-col>
                  <v-btn color="#ff4e00" dark large block router-link :to="'/About/'+id" class="prfont">
                    Edit&nbsp;
                   
                  </v-btn>
            </v-col> -->
            <div>
              
              <v-row v-if="prodata.instock">
                <!-- <v-col>
                  <v-btn color="#ff4e00" dark large block router-link :to="'/About/'+id" class="prfont">
                    Buy Now&nbsp;
                    <v-icon>mdi-shopping</v-icon>
                  </v-btn>
                </v-col> -->
                <v-col>
                  
                </v-col>
              </v-row>
              <v-row v-else>
                <h3
                  style="color:black;font-weight:500;font-size:20px;padding-top:40px;"
                >Out of stock</h3>
              </v-row>
            </div>
          </v-flex>
          <v-flex md5 v-else>
            
          </v-flex>
          <v-flex md6>
            <div>
              <h3 class="prfont"
                style="color:black;font-weight:500;font-size:20px;padding-top:20px;"
              >{{prodata.productname}}{{log}}</h3>
            </div>
            <div>
              <star-rating v-if="st"
                v-bind:increment="1"
                v-bind:star-size="16"
                active-color="#ff4e00"
                :read-only="true"
                v-bind:rating="avg"
                required
              ></star-rating>
            </div>
            <div style="font-size:16px;padding-top:8px;">
              <strong style="color:black;font-size:16px;" class="prfont">{{prodata.description}}</strong>
            </div>
            <br />
            <div>
              <strong style="color:black;font-weight:500;font-size:25px;" class="prfont">₹{{prodata.price}}</strong>
            </div>
            <br />
            <div v-if="prodata.instock" style="color:black;">
              <h3>
                <strong class="prfont">(In Stock)</strong>
              </h3>
            </div>
            <div v-else>
              <h3>
                <strong class="prfont">(Out of Stock)</strong>
              </h3>
            </div>
            <br />
            <!-- <v-row>
              <v-col>
                <div  style="font-size:16px; color:black;" v-if="prodata.isinseason">
                  <strong style="color:black;" class="prfont">Inseason:Yes</strong>
                </div>
                <div v-else style="font-size:16px">
                  <strong style="color:black;" class="prfont">Inseason:No</strong>
                </div>
              </v-col>
              <v-col>
                <div style="font-size:16px" v-if="prodata.isseasonal">
                  <strong style="color:black;" class="prfont">Isseasonal:Yes</strong>
                </div>
                <div v-else style="font-size:16px">
                  <strong style="color:black;" class="prfont">Isseasonal:No</strong>
                </div>
              </v-col>
             
            </v-row> -->
             <v-flex md6>
                 <h3 style="color:black;" >
                        <strong class="prfont">Highlights</strong>
                      </h3>
              </v-flex>
            <v-row v-for="i in highlights" >
            
                <v-col md="7">
                 <h5 style="color:black;padding-left:10px;">
                        <strong class="prfont">* {{i}}</strong>
                      </h5>
              </v-col>
            </v-row>
              <v-card class="mx-auto" outlined>
              <div>
                <div style="font-size:20px;font-weight:500;padding-left:20px;">
                  <v-row>
                    <v-col md="6">
                      <h3 style="color:black;font-weight:500;font-size:20px;">
                        <strong class="prfont">Specifications</strong>
                      </h3>
                    </v-col>
                    <!-- <v-col md="2"></v-col> -->
                
                  </v-row>
                </div>
                <v-divider></v-divider>
                <div class="col-md -12 row" v-for="i in specifications" style="margin-top:0px;">
                <div class='col-md-5'>
                <h4 class="prfont" style="color:black;">{{i.name}}</h4>
              </div>
                <div class='col-md-4'>
                <h4 class="prfont" style="color:black;">{{i.value}}</h4>
              </div>


              
                </div>
              </div>
            </v-card>
            <br>
            
            <v-card class="mx-auto" outlined v-if="st">
              <div>
                <div style="font-size:20px;font-weight:500;padding-left:20px;">
                  <v-row>
                    <v-col md="6">
                      <h3 style="color:black;font-weight:500;font-size:20px;">
                        <strong class="prfont">Ratings & Reviews</strong>
                      </h3>
                    </v-col>
                    <v-col md="2"></v-col>
                    <v-col md="4">
                      <v-row justify="center">
                        <v-dialog v-model="ratingdialog" persistent max-width="350">
                          <template v-slot:activator="{ on }">
                            <v-card>
                              <span
                                v-on="on"
                                style="font-size:14px;background-color:#ff4e00;color:white;padding-left:10px;padding-right:10px;padding-top:5px;padding-bottom:5px; "
                              >
                                <strong class="prfont">RATE PRODUCT</strong>
                              </span>
                              <!-- <v-btn color="#ff4e00" dark large block
                                v-on="on"
                                style="padding-left:20px;padding-right:20px;padding-bottom:5px;padding-top:5px;"
                              >Rate Product</v-btn>-->
                            </v-card>
                          </template>
                          <v-card class="rounded-card">
                            <v-card-title class="headline" >Rate product</v-card-title>
                            <div class="row">
                              <div class="col-md-3"></div>
                              <div class="col-md-6">
                                <v-form ref="form" lazy-validation>
                                  <star-rating
                                    v-bind:increment="1"
                                    v-bind:star-size="20"
                                    active-color="#00A6FF"
                                    v-bind:rating="Number(rating)"
                                    v-model="rating"
                                    required
                                  ></star-rating>

                                  <br />
                                  <v-text-field
                                    label="Comments"
                                    type="text"
                                    class="form-control"
                                    id="comment"
                                    v-model="comment"
                                    required
                                  />

                                  <br />
                                </v-form>
                              </div>
                            </div>
                            <v-card-actions v-if=" stat">
                              <v-btn color="red" text @click="ratingdialog = false">Cancel</v-btn>
                              <v-spacer />
                              <v-btn color="#0e4e35" text @click="reviewEdit">Edit</v-btn>
                            </v-card-actions>
                            <v-card-actions v-else>
                              <v-btn color="red" text @click="ratingdialog = false">Cancel</v-btn>
                              <v-spacer />
                              <v-btn color="#0e4e35" text @click="addReview">Submit</v-btn>
                            </v-card-actions>
                          </v-card>
                        </v-dialog>
                      </v-row>
                    </v-col>
                  </v-row>
                </div>
                <v-divider></v-divider>
                <div class="col-md -12 row">
                  <div class="col-md-3" style="padding-top:70px;">
                    <div class="rating-overview-box">
                      <span class="rating-overview-box-total">{{avg}}</span>
                      <span class="rating-overview-box-percent">out of 5.0</span>
                      <star-rating
                        v-bind:increment="0.01"
                        v-bind:star-size="14"
                        v-bind:read-only="true"
                        v-bind:rating="Number(5.0)"
                        required
                      ></star-rating>
                    </div>
                  </div>
                  <div class="col-md-9">
                    <div class="row redu">
                      <div class="col-md-2">
                        5
                        <i style="font-size: 10px;" class="fas fa-star"></i>
                      </div>
                      <div class="col-md-6">
                        <v-progress-linear :value="((fivestarcount/count)*100)" color="#ff4e00"></v-progress-linear>
                      </div>
                      <div class="col-md-2">{{fivestarcount}}</div>
                    </div>
                    <div class="row redu" style="margin-bottom:0">
                      <div class="col-md-2">
                        4
                        <i style="font-size: 10px;" class="fas fa-star"></i>
                      </div>
                      <div class="col-md-6">
                        <v-progress-linear :value="((fourstarcount/count)*100)" color="#ff4e00"></v-progress-linear>
                      </div>
                      <div class="col-md-2">{{fourstarcount}}</div>
                    </div>
                    <div class="row redu">
                      <div class="col-md-2">
                        3
                        <i style="font-size: 10px;" class="fas fa-star"></i>
                      </div>
                      <div class="col-md-6">
                        <v-progress-linear :value="((threestarcount/count)*100)" color="#ff4e00"></v-progress-linear>
                      </div>
                      <div class="col-md-2">{{threestarcount}}</div>
                    </div>
                    <div class="row redu">
                      <div class="col-md-2">
                        2
                        <i style="font-size: 10px;" class="fas fa-star"></i>
                      </div>
                      <div class="col-md-6">
                        <v-progress-linear :value="((twostarcount/count)*100)" color="#ff4e00"></v-progress-linear>
                      </div>
                      <div class="col-md-2">{{twostarcount}}</div>
                    </div>
                    <div class="row redu">
                      <div class="col-md-2">
                        1
                        <i style="font-size: 10px;" class="fas fa-star"></i>
                      </div>
                      <div class="col-md-6">
                        <v-progress-linear :value="((onestarcount/count)*100)" color="#ff4e00"></v-progress-linear>
                      </div>
                      <div class="col-md-2">{{onestarcount}}</div>
                    </div>
                  </div>
                </div>
                <br />
                <hr />
                <div class="ety col-md-12" v-for="i in review">
                  <span class="RDstyle4 prfont">
                    {{i.rating}}&nbsp;
                    <i style="font-size:12px" class="fas fa-star"></i>
                  </span>&nbsp;
                  <span  class="prfont"
                    style="opacity:.6; font-size:20px;font-weight:600;"
                  >&nbsp;{{i.comment}}</span>

                  <h5 style="padding-top:10px;" class="prfont">{{i.comment}}</h5>

                  <h4 style="padding-top:10px;" class="prfont">{{i.user.firstname}}&nbsp;{{i.user.lastname}}</h4>
                </div>
                <br />

                
              </div>
            </v-card>
               <br> 

          
            <br />
          </v-flex>
        </v-layout>
      </v-container>
    </v-card>


   
    <br />
  </div>
</template>

<script>
import StarRating from "vue-star-rating";
import axios from "axios";
import AppSideNav from "@/components/common/AppSideNav";
import VueSelectImage from "vue-select-image";

export default {
  props: ["id"],
  components: {
    AppSideNav,
    StarRating,
    VueSelectImage
  },
  data() {
    return {
      st:false,
      status:false,
      reviewid: "",
      stat: "false",
      avg: "",
      count: "",
      onestarcount: "",
      twostarcount: "",
      threestarcount: "",
      fourstarcount: "",
      fivestarcount: "",
      imageDisplay: null,
      myReview: [],
      review: [],
      rating: "",
      comment: "",
      menu2: false,
      ratingdialog: false,
      rating: "",
      comment: "",
      dataImages: null,
      photos: null,
      images: [],
      photos: null,
      stat: false,
      prodata: [],
      product: {
        name: null,
        price: null,
        desc: null,
        instock: null,
        seller: null,
        id: null,
        status: null,

        myRev: [],
        myinfo: [],
        rid: "",
        id: localStorage.getItem("id"),
        user: ""
      }
    };
  },
  mounted: function() {
   
  },
  beforeMount() {
    this.getproductid();
  },
  methods: {
    onSelectImage(event) {
      console.log(event);
      this.imageDisplay = event.src;
      this.deleteId = event.id;
    },
    getproductid() {
      axios({
        method: "GET",
        url: "/product/infobyname?name=" + this.id
      }).then(Response => {
        if (Response.data.status == true) {
          this.id = Response.data.data._id;

          this.profileView();

          this.getproduct();
          this.getStatus();
          this.reviewView();
        this.dup();
           this.reviewInfo();
    this.getReview();
    // this.reviewEdit();
    // this.myReview();
    this.profileView();
    this.newReview();
        } else alert(Response.data.msg);
      });
    },
    imguplderr(resp) {
      console.log(resp);
    },
    getReview() {
      axios({
        method: "GET",
        url: "/review/productwise?productid=" + this.id
      }).then(Response => {
        // console.log(Response);
        console.log(this.id);
        this.review = Response.data.data;
        this.status=Response.data.status;

        // this.comment = Response.data.data.comment;
        // this.rating = Response.data.data.rating;
        this.onestarcount = Response.data.onestarcount;
        this.twostarcount = Response.data.twostarcount;
        this.threestarcount = Response.data.threestarcount;
        this.fourstarcount = Response.data.fourstarcount;
        this.fivestarcount = Response.data.fivestarcount;
        this.count = Response.data.count;
        this.avg = Response.data.avg;
      });
    },
  dup() {
      axios({
        method: "GET",
        url: "/review/checkduplicate?productid=" + this.id,

        headers: {
          "x-auth-token": localStorage.getItem("token")
        }
      }).then(Response => {
        this.st=Response.data.status;
      
      });
    },
    reviewView() {
      axios({
        method: "GET",
        url: "/review/myreviews/",

        headers: {
          "x-auth-token": localStorage.getItem("token")
        }
      }).then(Response => {
        // console.log(Response);
        this.myRev = Response.data.data;

        this.comment = Response.data.data.comment;
        this.rating = Response.data.data.rating;
      });
    },
    newReview() {
      axios({
        method: "GET",
        url: "/review/product/myreviews?productid=" + this.id,

        headers: {
          "x-auth-token": localStorage.getItem("token")
        }
      }).then(Response => {
        // console.log(Response);
        this.myRev = Response.data.data;
        this.stat = Response.data.status;

        this.comment = Response.data.data.comment;
        this.rating = Response.data.data.rating;
        this.reviewid = Response.data.data._id;
      });
    },
    profileView() {
      axios({
        method: "GET",
        url: "/user/profile/",

        headers: {
          "x-auth-token": localStorage.getItem("token")
        }
      }).then(Response => {
        // console.log(Response);
      });
    },
    reviewInfo() {
      axios({
        method: "GET",
        url: "/review/info?id=" + this.rid,

        headers: {
          "x-auth-token": localStorage.getItem("token")
        }
      }).then(Response => {
        // console.log(Response);
        this.myinfo = Response.data.data;
        this.comment = Response.data.data.comment;
        this.rating = Response.data.data.rating;
      });
    },
    reviewEdit() {
      var data = {};
      data["reviewid"] = this.reviewid;
      data["comment"] = this.comment;
      data["rating"] = this.rating;

      axios({
        method: "POST",
        url: "/Review/Edit/",
        data: data,

        headers: {
          "x-auth-token": localStorage.getItem("token")
        }
      })
        .then(response => {
          if (response.data.status == true) {
            this.msg = response.data.msg;

            this.$dlg.alert(
              this.msg,
              () => {
                this.ratingdialog = false;
                window.location.reload();
              },
              { messageType: "success" }
            );
          } else {
            this.msg = response.data.msg;
            this.$dlg.alert(this.msg, () => {}, { messageType: "error" });
          }
        })
        .catch(e => {
          this.msg = "Not Success";
          this.$dlg.alert(this.msg, () => {}, { messageType: "error" });
        });
    },
    getproduct() {
      axios({
        method: "GET",
        url: "/product/info?id=" + this.id
      }).then(Response => {
        // console.log(Response);
        this.prodata = Response.data.data;
         this.specifications=Response.data.data.specifications;
         this.highlights=Response.data.data.highlights;
         
        this.photos = Response.data.data.photos;

        var tempflag = [];
        for (var i = 0; i < this.photos.length; i++) {
          var tyimg = {
            src: "https://api.inguzsales.in/u/" + this.photos[i],
            // src: $Image_URL + this.regions[i].flag,
            id: this.photos[i]
          };
          tempflag.push(tyimg);
        }
        this.dataImages = tempflag;
      });
    },
    getStatus() {
      axios({
        method: "GET",
        url: "/Cart/doexist?productid=" + this.id,

        headers: {
          "x-auth-token": localStorage.getItem("token")
        }
      }).then(Response => {
        // console.log(Response);
        this.stat = Response.data.status;
      });
    },
    addCart() {
      var data = {};
      data["productid"] = this.id;
      data["quantity"] = 1;
      axios({
        method: "POST",
        url: "/Cart/Addorupdate/",
        data: data,
        headers: {
          "x-auth-token": localStorage.getItem("token")
        }
      }).then(Response => {
        // console.log(Response);

        this.$router.push("/Purchase/" + this.id);
      });
    },
    addReview() {
      var data = {};
      data["productid"] = this.id;
      data["rating"] = this.rating;
      data["comment"] = this.comment;
      axios({
        method: "POST",
        url: "/Review/Add",
        data: data,
        headers: {
          "x-auth-token": localStorage.getItem("token")
        }
      })
        .then(response => {
          if (response.data.status == true) {
            this.msg = response.data.msg;
            this.rid = response.data.id;
            this.$dlg.alert(
              this.msg,
              () => {
                this.ratingdialog = false;
                // this.getproduct();
                window.location.reload();
              },
              { messageType: "success" }
            );
          } else {
            this.msg = response.data.msg;
            this.$dlg.alert(this.msg, () => {}, { messageType: "error" });
          }
        })
        .catch(e => {
          this.msg = "Not Success";
          this.$dlg.alert(this.msg, () => {}, { messageType: "error" });
        });
    }
  }
};
</script>
<style scoped>
.prfont {
  font-family: "Montserrat";
}
.rating-overview {
  display: flex;
  margin: 35px 0 25px 0;
  background: #fff;
  border-radius: 4px;
  padding: 30px;
  padding-right: 20px;
  border: 1px solid #e8e8e8;
}
.rating-overview-box {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  border: navajowhite;
  width: 135px;
  margin-right: 20px;
  text-align: center;
  border-radius: 0;
  border-right: 1px solid #e8e8e8;
  padding-right: 27px;
}
.rating-overview-box-total {
  font-size: 44px;
  font-weight: 400;
  line-height: 1em;
  display: block;
  color: #333;
}
.rating-overview-box-percent {
  font-size: 15px;
  margin-bottom: 0;
  color: #888;
  display: block;
}
.rating-overview-box .star-rating {
  font-size: 16px;
  margin: 0;
  display: block;
  letter-spacing: -0.5px;
}
.rating-bars {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  flex-basis: 100%;
  margin: 0;
  padding: 0;
  margin-top: 0;
  align-items: center;
}
.RDstyle4 {
  color: white;
  background-color: #ff4e00;
  padding: 4px;
  border-radius: 5px;
}
.RDstyle1 {
  padding-left: 0px !important;
  padding-right: 0px !important;
}
.RDstyle2 {
  padding-left: 0px !important;
  padding-right: 0px !important;
  margin-left: 30px !important;
}
.RDstyle3 {
  color: white;
}
.prog-pdng {
  padding-top: 10px !important;
}
hr.line {
  border-top: opx solid black;
  opacity: 0;
}
.bg-variant.ash {
  background-color: gray;
}
.ratingbars2 {
  display: none;
}
.barpdng {
  padding-bottom: 20px !important;
}
/* media query */
@media only screen and (min-device-width: 360px) and (max-device-width: 767px) {
  .ratingbars1 {
    display: none;
  }
  .ratingbars2 {
    display: inline-block;
  }
  .RDstyle2 {
    padding-top: 30px;
    margin-left: 0px !important;
    margin-right: 30px !important;
  }
  .RDstyle5 {
    padding-right: 0px !important;
    margin-left: 5px !important;
  }
  .RDstyle1 {
    margin-left: -15px !important;
    margin-right: -15px !important;
  }
}
@media only screen and (min-device-width: 768px) {
  .ratingbars2 {
    display: none;
  }
  .RDstyle5 {
    margin-left: 35px !important;
  }
}
@media only screen and (min-width: 360px) and (max-width: 767px) {
  .ratingbars1 {
    display: none;
  }
  .ratingbars2 {
    display: inline-block;
  }
}
.ety {
  padding-top: 20px;
  padding-bottom: 20px;
}
.redu {
  margin-bottom: 0 !important;
}
</style>
